import React from "react";
import {useLocation, useParams} from "react-router-dom";
import GenericTemplate from "../../../templates/GenericTemplate";
import {parseInt} from "lodash";
import AdGroupEditMs from "./AdGroupEditMs";
import {
    APOLLO_GROUP_OPERATOR,
    APOLLO_SYSTEM_ADMIN,
    ApolloPageUsagePermission
} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {AdGroupProcessType} from "./common/CommonConst";

/*
    画面名：広告グループ作成（MS）
 */
const AdGroupCreateMs: React.FC = () => {

    // 0: 新規　、　id：編集
    const {
        accountgroupid,
        accountid,
        platformaccountid,
    } = useParams<{ accountgroupid: string; accountid: string, platformaccountid: string }>()

    const reqParams = new URLSearchParams(useLocation().search);
    const campaignId = reqParams.get("campaignId") ?? "0";
    const queryCampaignId = campaignId !== "0" ? `?campaignId=${campaignId}` : "";

    const breadcrumbsData: BreadcrumbsData = {
        categoryId: 24,
        breadId: 2,
        queries: ["", "", "", "", queryCampaignId],
        menu: {
            id: 2,
            accountId: platformaccountid,
            accountName: "",
        },
        campaign: null,
        adgroup: null,
        advertisement: null,
        asset: null,
    }

    return (
        <GenericTemplate title="">
            <CustomizedSnackbars/>
            <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                <ApolloBreadcrumbs2 data={breadcrumbsData}/>
                <AdGroupEditMs
                    accountGrpId={parseInt(accountgroupid)}
                    accountId={parseInt(accountid)}
                    platformaccountid={parseInt(platformaccountid)}
                    campaignId={parseInt(campaignId)}
                    adGroupId={null}
                    processType={AdGroupProcessType.create}
                />
            </ApolloPageUsagePermission>
        </GenericTemplate>
    );
};

export default AdGroupCreateMs;
